import { render, staticRenderFns } from "./IndicationForm.vue?vue&type=template&id=40337e24&"
import script from "./IndicationForm.vue?vue&type=script&lang=js&"
export * from "./IndicationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports